// FIX: Use named imports for Firebase v9+ modular SDK functions.
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
import { environment } from '../environments/environment';

// Use environment-specific Firebase configuration
export const firebaseConfig = environment.firebaseConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const FIREBASE_AUTH = getAuth(app);
export const FUNCTIONS = getFunctions(app);

// Initialize Firestore with environment-specific database
export const FIRESTORE = getFirestore(app, firebaseConfig.databaseId);

// Initialize Storage with environment-specific bucket
export const FIREBASE_STORAGE = getStorage(app, firebaseConfig.storageBucket);

// Initialize Analytics
export const ANALYTICS = getAnalytics(app);

// Log environment info in development
if (!environment.production) {
  console.log(`🔧 Firebase initialized in ${environment.environmentName} mode`);
  console.log(`📊 Database: ${firebaseConfig.databaseId}`);
  console.log(`📦 Storage: ${firebaseConfig.storageBucket}`);
  console.log(`📈 Analytics initialized`);
}

